import React from "react";
import { Button } from "../Button";
import { PopupCampaignAudienceEstimateViewModel } from "../../api/generated/models/PopupCampaignAudienceEstimateViewModel";
import { describeEstimate } from "../../helpers/popupCampaignTargeting";

interface Props {
  estimate: PopupCampaignAudienceEstimateViewModel | null;
  loading: boolean;
  onRecalculate: () => void;
  recalculating: boolean;
  /** True while there is unsaved targeting: recalculating would act on the server's stored
   * document, which next to an Audience card showing something else would be misleading. */
  recalculateDisabled?: boolean;
  /** The platforms the campaign targets, so the tile can say whether they were applied. */
  selectedPlatforms?: readonly unknown[];
}

export const ReachTile: React.FC<Props> = ({
  estimate, loading, onRecalculate, recalculating, recalculateDisabled, selectedPlatforms = [],
}) => {
  const { headline, detail, calculating } = describeEstimate(estimate, selectedPlatforms);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm text-gray-500">Estimated reach</p>
          <p className={`text-2xl font-medium ${calculating ? "text-gray-400" : ""}`}>
            {loading ? "…" : headline}
          </p>
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onRecalculate}
          isLoading={recalculating}
          disabled={recalculateDisabled}
          title={recalculateDisabled ? "Save your targeting changes first" : undefined}
        >
          Recalculate
        </Button>
      </div>
      <p className="text-xs text-gray-500 mt-2">{detail}</p>
    </div>
  );
};
